export type DropdownArrowIconProps = {
    // MUI passes the positioning and open/closed rotation classes through this - Select uses MuiSelect-icon.
    className?: string;
};

// The chevron every dropdown in the portal points down with. Kept in one place so a Select and an Autocomplete
// cannot drift apart.
function DropdownArrowIcon(props: DropdownArrowIconProps) {
    return (
        <svg className={props.className} xmlns="http://www.w3.org/2000/svg" width="10.885" height="6.503" viewBox="0 0 10.885 6.503">
            <path d="M0,0,4.382,4.382,8.764,0" transform="translate(1.061 1.061)" fill="none" stroke="#000000" strokeLinecap="round" strokeWidth="1.5" />
        </svg>
    );
}

export default DropdownArrowIcon;
